import React, { Component } from 'react';
import Toggle from 'react-toggle';
import { UncontrolledTooltip } from "reactstrap";
import { v4 as uuidv4 } from 'uuid';

class ToggleField extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uniqueId: `id-${uuidv4()}`,
		};
	}
	render() {
		const {
			onChange,
			label,
			errorTrigger,
			errorMessage,
			disabled,
			style,
			inputStyle,
			checked,
			icons,
			information,
			alert,
			className
		} = this.props;
		const { uniqueId } = this.state;
		return (
			<div className={`formFieldContainer ${className ? className : ''}`} style={style}>
				<div className="toggleField">
					{label && <div className="labelContainer flex column">
						<div className={`toggleLabel mr-10`}>{label}{information ?
										<>
											<i
												id={uniqueId}

												className="grey las la-info-circle informationIcon mb-5"
											/>
											<UncontrolledTooltip
												className="tooltip formFieldTooltip"
												placement="right"
												target={uniqueId}
											>
												{information}
											</UncontrolledTooltip>
										</>
										: alert &&
										<>
											<i
												id={uniqueId}

												className="red las la-exclamation-triangle informationIcon mb-5"
											/>
											<UncontrolledTooltip
												className="tooltip formFieldTooltip"
												placement="right"
												target={uniqueId}
											>
												{alert}
											</UncontrolledTooltip>
										</>
									}</div>
						{errorTrigger && <div className="formFieldLabel mt-5 error">{errorMessage} </div>}
					</div>}
					<Toggle
						className='ml-a'
						style={inputStyle}
						checked={checked}
						icons={icons}
						disabled={disabled}
						onChange={onChange}
					/>
				</div>
			</div>
		);
	}
}

export default ToggleField;
